import { render, staticRenderFns } from "./ContarctorAdditionalInfo.vue?vue&type=template&id=a02e4a24"
import script from "./ContarctorAdditionalInfo.vue?vue&type=script&lang=ts"
export * from "./ContarctorAdditionalInfo.vue?vue&type=script&lang=ts"
import style0 from "./ContarctorAdditionalInfo.vue?vue&type=style&index=0&id=a02e4a24&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a02e4a24')) {
      api.createRecord('a02e4a24', component.options)
    } else {
      api.reload('a02e4a24', component.options)
    }
    module.hot.accept("./ContarctorAdditionalInfo.vue?vue&type=template&id=a02e4a24", function () {
      api.rerender('a02e4a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/ContarctorAdditionalInfo.vue"
export default component.exports